import { Outlet, useLocation } from "react-router-dom";
import {
  Layout,
  LayoutHeader,
  LayoutContent,
} from "@jana-technology/platform-ui";

import { NavbarContainer, SystemOverviewNavTabs } from "components/navbar";
import { OverviewAssetSelection } from "components/sidebar";

export const SystemOverviewLayout = () => {
  const { pathname } = useLocation();

  return (
    <Layout>
      <LayoutHeader>
        <NavbarContainer>
          <SystemOverviewNavTabs />
        </NavbarContainer>
      </LayoutHeader>
      <LayoutContent
        key={pathname}
        sidebar={<OverviewAssetSelection />}
        sidebarSize="sm"
        sidebarCollapsible
      >
        <Outlet />
      </LayoutContent>
    </Layout>
  );
};

export default SystemOverviewLayout;
